// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: mofKRyDpLo
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicCompanyDescriptionComp.module.css"; // plasmic-import: mofKRyDpLo/css

createPlasmicElementProxy;

export const PlasmicCompanyDescriptionComp__VariantProps = new Array();

export const PlasmicCompanyDescriptionComp__ArgProps = new Array(
  "brandSummaries"
);

const $$ = {};

function PlasmicCompanyDescriptionComp__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents:
          "McDonald\u2019s (MCD) is a fast food, limited service restaurant with more than 35,000 restaurants in over 100 countries. It employs more than four million people. McDonald\u2019s serves 70 million customers per day, which is greater than the population of France. According to IBISWorld, in 2014, McDonald\u2019s had the largest share in the fast food restaurant industry of 17% in the U.S. The closest competitor, Yum! Brands (or YUM), had a market share of 11%.",
        value: args.brandSummaries,
        className: classNames(sty.slotTargetBrandSummaries)
      })}
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCompanyDescriptionComp__ArgProps,
          internalVariantPropNames: PlasmicCompanyDescriptionComp__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCompanyDescriptionComp__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCompanyDescriptionComp";
  } else {
    func.displayName = `PlasmicCompanyDescriptionComp.${nodeName}`;
  }
  return func;
}

export const PlasmicCompanyDescriptionComp = Object.assign(
  // Top-level PlasmicCompanyDescriptionComp renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicCompanyDescriptionComp
    internalVariantProps: PlasmicCompanyDescriptionComp__VariantProps,
    internalArgProps: PlasmicCompanyDescriptionComp__ArgProps
  }
);

export default PlasmicCompanyDescriptionComp;
/* prettier-ignore-end */
